module.exports = __webpack_public_path__ + "static/media/img18.8727ca32.jpg";